import store from "../../../../store";
import { EMBED_TALK_EVENT_RESTRICT } from "../constants";
import { getUserConversationFromId } from "../../../common/apis/chat.apis";
import { aiActions } from "../../../ai/duck";

import Operations from "./operations";
import Actions from "./actions";

const noStateChange = {
  type: "",
};

const loginConfirmedListener = (socket, username) => {
  return (dispatch) => {
    if (username) {
      dispatch(Actions.setUserName(username));
      dispatch(Operations.conversationList(socket));
    } else {
      return noStateChange;
    }
  };
};

const roomJoinedEchoListener = (socket, roomId) => {
  const currentState = store.getState();
  const allConversations = currentState.chat.conversations;
  const conversationUpdated = allConversations.filter(
    (_conversation) => _conversation.conversationId === roomId
  );
  if (!conversationUpdated.length) {
    return (dispatch) => {
      console.log(
        "[c] - roomJoinedEchoListener Fetching conversation list: " + roomId
      );
      dispatch(Operations.conversationList(socket));
    };
  } else {
    return (dispatch) => noStateChange;
  }
};

const roomMessageListener = (socket, roomId, message) => {
  const currentState = store.getState();
  return (dispatch) => {
    if (!(message.isDeleted || message.isEdited || message.isHuddleEnded)) {
      // Update conversation's last activity (important for empty chat rooms)
      dispatch(Actions.updateConversationLastActivity(roomId, message));
    }

    // Always update the room messages
    dispatch(Actions.updateRoomMessages(roomId, message));

    try {
      const isDMConversation = currentState.chat.conversations?.filter(
        (_chat) => _chat.conversationId === roomId
      )[0]?.conversation?.isDM;

      // Send acknowledgment if this is the selected conversation
      if (
        isDMConversation &&
        currentState.chat.selectedConversationId === roomId
      ) {
        dispatch(
          Operations.sendMessageAcknowledgment(
            socket,
            roomId,
            currentState?.chat?.userName
          )
        );
      }
    } catch (err) {
      console.error("Error in roomMessageListener:", err);
      // Track error
      import("@sentry/react").then((Sentry) => {
        Sentry.captureException(err);
      });
    }
  };
};

const onTypingListener = (data) => {
  return (dispatch) => dispatch(Actions.setSystemTypingData(data));
};

const onMessageSeenListener = (data) => {
  return (dispatch) => dispatch(Actions.setSystemMessageSeenData(data));
};

const roomUserJoinedListener = (socket, roomName, participantId) => {
  const currentState = store.getState();
  const allConversations = currentState.chat.conversations;
  const userName = currentState.chat?.userName;
  return (dispatch) => {
    if (userName !== participantId) {
      const participantsData = currentState.chat?.participants[roomName]?.list;
      const isParticipantDataPresent = participantsData?.some(
        (_participant) => participantId === _participant.participantId
      );
      if (!isParticipantDataPresent) {
        dispatch(
          Operations.conversationParticipants({
            conversationId: roomName,
            participantIds: [participantId],
          })
        );
      }
    } else {
      const conversationJoined = allConversations.filter(
        (_conversation) => _conversation.conversationId === roomName
      );
      if (!conversationJoined.length) {
        console.log(
          "[c] - roomUserJoinedListener 107 Fetching single conversation"
        );

        // Fetch just this specific conversation and add it to the list
        getUserConversationFromId(
          roomName,
          (conversationData) => {
            dispatch(Actions.updateConversationsList(conversationData));
            // Join the room
            Operations.joinRoom(socket, roomName);
          },
          (error) => {
            console.error("Failed to fetch new conversation:", error);
            // Fallback to fetching entire list if single fetch fails
            dispatch(Operations.conversationList(socket));
          }
        );
      }
    }
  };
};

// Will be using this event to update the conversationList for now
const directMessageListener = (socket, message) => {
  if (message.type === "roomAddToList" && message.roomId) {
    Operations.joinRoom(socket, message.roomId);
  } else if (message.type === EMBED_TALK_EVENT_RESTRICT) {
    localStorage.setItem(
      `${message.eventId}:${EMBED_TALK_EVENT_RESTRICT}`,
      "true"
    );
    return (dispatch) =>
      dispatch(
        Actions.updateUserPermissions(
          message.eventId,
          EMBED_TALK_EVENT_RESTRICT,
          "true"
        )
      );
  }

  return (dispatch) => noStateChange;
};

// Required to Notify user when the user creates a room
const systemMessageListener = (socket, message) => {
  if (message?.type === "roomAddToList" && message?.roomId) {
    Operations.joinRoom(socket, message.roomId);
  }

  return (dispatch) => noStateChange;
};

const roomLeaveListener = (socket) => {
  const currentState = store.getState();
  const allConversations = currentState.chat.conversations;
  allConversations?.forEach((_conversation) => {
    socket.emit("roomLeave", _conversation.conversationId, (err, data) => {
      console.log("roomLeave", err, data);
    });
  });
};

const pollVoteListener = (payload, callBack) => {
  return callBack(payload);
};

const interestedPostListener = (payload, callBack = null) => {
  const currentState = store.getState();
  const { roomName, messageId, topicId, userId } = payload;
  let messages = currentState.chat?.chatLogs[roomName];
  if (topicId && messages) {
    messages = messages[topicId];
  }
  let message = null;
  messages?.some((_msg, index) => {
    if (_msg?.messageId === messageId) {
      if (!_msg.metadata?.interestedBy) {
        _msg.metadata = {
          interestedBy: [userId],
        };
      } else if (!_msg.metadata.interestedBy.includes(userId)) {
        _msg.metadata.interestedBy.push(userId);
      }
      message = _msg;
    }
    return false;
  });
  return (dispatch) =>
    dispatch(Operations.updateMessage(roomName, topicId, message));
};

const undoInterestedPostListener = (payload, callBack = null) => {
  const currentState = store.getState();
  const { roomName, messageId, topicId, userId } = payload;
  let messages = currentState.chat?.chatLogs[roomName];
  if (topicId && messages) {
    messages = messages[topicId];
  }
  let message = null;
  messages?.some((_msg, index) => {
    if (_msg?.messageId === messageId) {
      if (_msg.metadata?.interestedBy?.length) {
        _msg.metadata = {
          interestedBy: _msg.metadata?.interestedBy?.filter(
            (_userId) => _userId !== userId
          ),
        };
      }
      message = _msg;
    }
    return false;
  });
  return (dispatch) =>
    dispatch(Operations.updateMessage(roomName, topicId, message));
};

const handleHuddleJoinListener = (message) => {
  const currentState = store.getState();
  const currentPlayerId = currentState?.user?.gamePlayerProfile?.gamePlayerId;

  if (currentPlayerId !== message.huddleOwnerId) {
    return;
  }

  const userAddress = message.userAddress;

  return (dispatch) => {
    const message = `Hey! Looks like ${
      userAddress || "an internal employee"
    } has joined the call to assist you! I will be on standby while they guide you.`;
    dispatch(aiActions.vapiSayAndMuteAfter(message, false));

    dispatch(
      aiActions.sendVapiBackgroundMessage(
        `IMPORTANT: An internal employee ${
          userAddress || ""
        } has joined the call to assist the user, you are now on mute and will not be heard. 
        Simply stay mute and do **not** try to interrupt the conversation. Simply stay idle and do not respond in any way what so ever.
        All your responses must be completely empty.


        **IMPORTANT** You **MUST NOT** end or leave the call at any case. You MUST stay in the call until the user or ${userAddress} ends the call.`,
        "system"
      )
    );
  };
};

const handleHuddleCallRejectionListener = (message) => {
  const currentState = store.getState();
  const currentPlayerId = currentState?.user?.gamePlayerProfile?.gamePlayerId;

  if (currentPlayerId !== message.huddleOwnerId) {
    return;
  }

  const userAddress = message.userAddress || "Someone";

  return (dispatch) =>
    dispatch(
      aiActions.sendVapiBackgroundMessage(
        `${userAddress} cannot join the call. Address the same to the user`,
        "system"
      )
    );
};

const conversationSyncListener = (data) => {
  const currentState = store.getState();
  const { roomName } = data;

  // Get correct topicId from selectedConversationTopic (NOT selectedTopicId)
  const topicId = currentState.chat.selectedConversationTopic?._id || null;

  // Fresh fetch - replaces messages with latest from API
  return (dispatch) => {
    dispatch(Operations.conversationHistory(roomName, topicId));
  };
};

export const ChatListeners = {
  loginConfirmed: loginConfirmedListener,
  roomMessage: roomMessageListener,
  onTyping: onTypingListener,
  onMessageSeen: onMessageSeenListener,
  roomJoinedEcho: roomJoinedEchoListener,
  roomUserJoined: roomUserJoinedListener,
  directMessage: directMessageListener,
  systemMessage: systemMessageListener,
  roomLeave: roomLeaveListener,
  pollVote: pollVoteListener,
  interestedPost: interestedPostListener,
  undoInterestedPost: undoInterestedPostListener,
  handleHuddleJoin: handleHuddleJoinListener,
  handleHuddleCallRejection: handleHuddleCallRejectionListener,
  conversationSync: conversationSyncListener,
};
